import { makeStyles } from '@material-ui/core';
import { vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

export const styles = makeStyles(theme => ({
  titleContainer: {
    height: '8.8vh',
  },
  titleHeader: {
    color: themeColor.modalTitle,
    fontSize: vw(2.18),
    fontWeight: 500,
  },
  titleBar: {
    color: themeColor.infoMain,
    letterSpacing: 0.44,
    lineHeight: 1.25,
    fontSize: vw(2.08),
    borderTop: `5px solid ${theme.palette.secondary.main}`,
    width: '50px',
  },
}));
